export const MIN_WIDTH_TILE = 248;
